import styled from "styled-components";

export const FooterButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  gap: 8px;

  button {
    min-width: 100px;
    padding: 20px;
  }
`;
